var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('div',{staticClass:"en-details",on:{"click":_vm.close}},[_c('div',{staticClass:"content"},[_vm._v(" "+_vm._s(_vm.content ? _vm.content : "您还没进行输入")+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }